/*
 * @Author: 317473294@qq.com
 * @Date: 2023-05-24 10:27:20
 * @LastEditTime: 2023-10-22 16:27:22
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /english_admin_v1.1.0/src/api/menu.js
 */
//导入请求拦截与响应拦截，每次请求，都会经过请求拦截，请求结束会产生响应拦截，
import Axios from "../axios"

//获取菜单
export function getMenu(data){
    console.log(data)
    return Axios({
        method:"get",
        url:"/api/getMenu",
        data:data
    })
}
//添加菜单
export function addMenus(data){
    console.log(data)
    return Axios({
        method:"post",
        url:"/api/addMenu",
        data:data
    })
}

//更新菜单
export function updataMenu(data){
    return Axios({
        method:"post",
        url:"/api/updataMenu",
        data:data
    })
}
//删除菜单
export function deleteMenu(data){
    return Axios({
        method:"post",
        url:"/api/deleteMenu",
        data:data
    })
}
//权限菜单
export function getRoleMenu(data){
    return Axios({
        method:"post",
        url:"/api/getRoleMenu",
        data:data
    })
}



// WEBPACK FOOTER //
// ./src/api/menu.js